// src/utils/analytics.ts
// Fire-and-forget analytics — wraps the logAnalyticsEvent Lambda endpoint.
// Never throws. Never awaited. Safe to call anywhere.

import { fetchAuthSession } from 'aws-amplify/auth';
import { getAmplifyCustomOutput } from '@/lib/environment';

export function logEvent(
  event: string,
  metadata?: Record<string, unknown>,
): void {
  void (async () => {
    try {
      const session = await fetchAuthSession({ forceRefresh: false });
      const idToken = session.tokens?.idToken?.toString();
      if (!idToken) return;

      const apiBase = getAmplifyCustomOutput('PaymentAPIEndpoint');
      if (!apiBase) return;

      await fetch(`${apiBase}log-analytics-event`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`,
        },
        body: JSON.stringify({ event, metadata: metadata ?? null }),
      });
    } catch {
      // fire-and-forget — swallow all errors
    }
  })();
}
